/**
 * @file 公共配置文件
 * */
const config = require('./dictionary')
const { NODE_ENV } = process.env
let apiUrl = ''
for (const i of config.menu) {
    if (NODE_ENV === i.nodeEnv) {
        apiUrl = i.apiUrl
    }
}

module.exports = apiUrl